import { FC, useEffect } from 'react';
import { ExitSlipResult } from '../../models/ExitSlip';
import { motion } from 'motion/react';
import IceCubesResult from './DashboardIcons/IceCubesResult';
interface Props {
  exitSlipResult: ExitSlipResult[];
  setIsExitSlipFinished: (i: boolean) => void;
}

const DashboardExitSlipModalResult: FC<Props> = ({ exitSlipResult, setIsExitSlipFinished }) => {
  const correctAnswers = exitSlipResult.filter(el => el.score === el.maxScore);
  const wrongAnswers = exitSlipResult.filter(el => el.score !== el.maxScore);
  const avg = correctAnswers.length / exitSlipResult.length;

  const messageMap = (resultLength: number, correctAnswerLength: number) => {
    let html = <></>;
    if (resultLength === 2) {
      if (correctAnswerLength === 0)
        html = (
          <>
            Today was a challenge, but you’ll have <span className="tw-font-bold">more chances to build this up</span>
          </>
        );
      if (correctAnswerLength === 1)
        html = (
          <>
            Nice try! A <span className="tw-font-bold">little more practice</span> will lock it in
          </>
        );
      if (correctAnswerLength === 2)
        html = (
          <>
            Nicely done! You’ve got a <span className="tw-font-bold">strong grasp</span> of this
          </>
        );
    }
    if (resultLength === 3) {
      if (correctAnswerLength === 0 || correctAnswerLength === 1)
        html = (
          <>
            Today was a challenge, but you’ll have <span className="tw-font-bold">more chances to build this up</span>
          </>
        );
      if (correctAnswerLength === 2)
        html = (
          <>
            Good effort! You’ve got the <span className="tw-font-bold">basics down</span>
          </>
        );
      if (correctAnswerLength === 3)
        html = (
          <>
            Nicely done! You’ve got a <span className="tw-font-bold">strong grasp</span> of this
          </>
        );
    }
    if (resultLength === 4) {
      if (correctAnswerLength === 0 || correctAnswerLength === 1)
        html = (
          <>
            Today was a challenge, but you’ll have <span className="tw-font-bold">more chances to build this up</span>
          </>
        );
      if (correctAnswerLength === 2)
        html = (
          <>
            <span className="tw-font-bold">You{`'`}re getting there!</span> Every attempt helps you learn more
          </>
        );
      if (correctAnswerLength === 3)
        html = (
          <>
            Good effort! You’ve got the <span className="tw-font-bold">basics down</span>
          </>
        );
      if (correctAnswerLength === 4)
        html = (
          <>
            Nicely done! You’ve got a <span className="tw-font-bold">strong grasp</span> of this
          </>
        );
    }
    if (resultLength === 5) {
      if (correctAnswerLength === 0)
        html = (
          <>
            Today was a challenge, but you’ll have <span className="tw-font-bold">more chances to build this up</span>
          </>
        );
      if (correctAnswerLength === 1)
        html = (
          <>
            <span className="tw-font-bold">You{`'`}re getting there!</span> Every attempt helps you learn more
          </>
        );
      if (correctAnswerLength === 2)
        html = (
          <>
            Nice try! A <span className="tw-font-bold">little more practice</span> will lock it in
          </>
        );
      if (correctAnswerLength === 3)
        html = (
          <>
            Good effort! You’ve got the <span className="tw-font-bold">basics down</span>
          </>
        );
      if (correctAnswerLength === 4)
        html = (
          <>
            Nicely done! You’ve got a <span className="tw-font-bold">strong grasp</span> of this
          </>
        );
      if (correctAnswerLength === 5)
        html = (
          <>
            <span className="tw-font-bold">You nailed it!</span> Your understanding is spot on
          </>
        );
    }
    return html;
  };

  useEffect(() => {
    setIsExitSlipFinished(true);
  }, []);

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-6">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="tw-text-center"
      >
        {avg === 1 ? (
          <h3 className="tw-text-[#2E9079] tw-font-atkinson tw-font-normal tw-text-4xl">
            All <span className="tw-font-bold ">{exitSlipResult.length}</span> questions right
          </h3>
        ) : (
          <h3 className={`tw-font-atkinson tw-font-normal tw-text-4xl ${avg > 0.65 ? 'tw-text-[#2E9079]' : ''}`}>
            You got{' '}
            <span className="tw-font-bold">
              {correctAnswers.length} out of {exitSlipResult.length}
            </span>{' '}
            {avg > 0.65 ? 'questions right' : 'this time'}
          </h3>
        )}
      </motion.div>

      <IceCubesResult
        correctAnswers={correctAnswers}
        wrongAnswers={wrongAnswers}
        isPerfectScore={correctAnswers.length === exitSlipResult.length}
      />

      <motion.span
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.5,
          delay: 1.2,
          ease: [0.34, 1.56, 0.64, 1],
        }}
        style={{ transformOrigin: 'top right' }}
        className="lg:tw-max-w-[60%] tw-z-[100] tw-font-atkinson tw-text-xl tw-rounded-3xl tw-text-center tw-border tw-border-neutral-100 tw-bg-stone-0 tw-border-solid tw-p-4"
      >
        {messageMap(exitSlipResult.length, correctAnswers.length)}
      </motion.span>
    </div>
  );
};

export default DashboardExitSlipModalResult;
